import React from 'react';

const SIGNAL_CONFIG = {
  BULLISH: { label: 'BULLISH', color: '#22c55e', bg: 'rgba(34,197,94,0.12)', icon: '▲' },
  BEARISH: { label: 'BEARISH', color: '#ef4444', bg: 'rgba(239,68,68,0.12)', icon: '▼' },
  NEUTRAL: { label: 'RANGE BOUND', color: '#a1a1aa', bg: 'rgba(161,161,170,0.10)', icon: '●' },
  NO_TRADE: { label: 'NO TRADE', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', icon: '⛔' },
  EXIT_TRADE: { label: 'EXIT', color: '#f97316', bg: 'rgba(249,115,22,0.12)', icon: '⚠' },
  OK: { label: 'OK', color: '#22c55e', bg: 'rgba(34,197,94,0.08)', icon: '✓' },
  WAITING: { label: 'WAITING', color: '#6b7280', bg: 'rgba(107,114,128,0.10)', icon: '⏳' },
};

export default function SignalBadge({ signal }) {
  const config = SIGNAL_CONFIG[signal] || SIGNAL_CONFIG.WAITING;
  return (
    <span
      className="signal-badge"
      style={{ color: config.color, background: config.bg, borderColor: config.color }}
    >
      {config.icon} {config.label}
    </span>
  );
}

export { SIGNAL_CONFIG };
